import React from 'react';

import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts';
import styled from 'styled-components';

import { GOAL_PROGRESS_OPTIONS_MAP } from 'constants/ProjectConstants';
import { getColorFromKey } from 'constants/helper';
import theme from 'constants/theme';

const KEYS_FOR_PROGRESS_BAR = ['AT_RISK', 'CLOSED', 'OFF_TRACK', 'ON_TRACK'];

const StackedProgressBar = ({ data }) => {
  let modifiedData = { ...data };

  KEYS_FOR_PROGRESS_BAR.forEach((k) => {
    if (
      modifiedData[k] &&
      modifiedData[k]?.avgCompletionPercentage &&
      +modifiedData[k]?.avgCompletionPercentage === 0
    ) {
      try {
        modifiedData = { ...modifiedData, [k]: { ...modifiedData[k], avgCompletionPercentage: 1 } };
      } catch (err) {
        console.error('Error in setting value : ', err);
      }
    }
  });

  const sumOfAllCompletionPercentage = Object.values(data).map((v) => {
    if (v && v.avgCompletionPercentage) {
      return v.avgCompletionPercentage;
    }
    return 0;
  });

  const BASE_TRACK = {
    avgCompletionPercentage: 100 - +sumOfAllCompletionPercentage.reduce((pre, curr) => +pre + +curr, 0),
  };

  return (
    <ResponsiveContainer width="100%" height={10}>
      <StyledBarChart
        layout="vertical"
        data={[{ ...modifiedData, BASE_TRACK }]}
        margin={{
          //   top: 20,
          right: 0,
          //   bottom: 20,
          left: 0,
        }}
        stackOffset="expand"
      >
        <XAxis hide type="number" />
        <YAxis type="category" hide />
        {modifiedData.ON_TRACK !== null && (
          <Bar
            dataKey="ON_TRACK.avgCompletionPercentage"
            radius={[10, 0, 0, 10]}
            fill={getColorFromKey(GOAL_PROGRESS_OPTIONS_MAP.ON_TRACK.color)}
            stackId="a"
          />
        )}
        {modifiedData.OFF_TRACK !== null && (
          <Bar
            dataKey="OFF_TRACK.avgCompletionPercentage"
            fill={getColorFromKey(GOAL_PROGRESS_OPTIONS_MAP.OFF_TRACK.color)}
            stackId="a"
            // radius={
            //   !BASE_TRACK?.avgCompletionPercentage && !data.ON_TRACK
            //     ? [0, 10, 10, 0]
            //     : [!data.ON_TRACK ? 10 : 0, 0, 0, !data.ON_TRACK ? 10 : 0]
            // }
          />
        )}

        {modifiedData.AT_RISK !== null && (
          <Bar
            dataKey="AT_RISK.avgCompletionPercentage"
            fill={getColorFromKey(GOAL_PROGRESS_OPTIONS_MAP.AT_RISK.color)}
            stackId="a"
            // radius={
            //   !BASE_TRACK?.avgCompletionPercentage && !data.CLOSED
            //     ? [!data.ON_TRACK ? 10 : 0, 10, 10, !data.ON_TRACK ? 10 : 0]
            //     : [!data.OFF_TRACK ? 10 : 0, 0, 0, !data.OFF_TRACK ? 10 : 0]
            // }
          />
        )}

        {modifiedData.CLOSED !== null && (
          <Bar
            dataKey="CLOSED.avgCompletionPercentage"
            fill={getColorFromKey(GOAL_PROGRESS_OPTIONS_MAP.CLOSED.color)}
            stackId="a"
            // radius={
            //   !BASE_TRACK?.avgCompletionPercentage
            //     ? [0, 10, 10, 0]
            //     : [!data.AT_RISK ? 10 : 0, 0, 0, !data.AT_RISK ? 10 : 0]
            // }
          />
        )}

        <Bar
          // radius={BASE_TRACK?.avgCompletionPercentage === 100 ? [10, 10, 10, 10] : [0, 10, 10, 0]}
          dataKey="BASE_TRACK.avgCompletionPercentage"
          fill={theme.palette.background.lightGrey3}
          stackId="a"
        />
      </StyledBarChart>
    </ResponsiveContainer>
  );
};

const StyledBarChart = styled(BarChart)`
  .recharts-surface {
    border-radius: 8rem;
  }
`;

export default StackedProgressBar;
